import React, { useEffect, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { GetAction } from '../../Component/GetAction'
import { RequireModule, PageHeader, formatInr } from './shared'

function DashboardPage() {
  const [stats, setStats] = useState(null)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      setLoading(true)
      const data = await GetAction('get', {}, 'dashboard/stats')
      if (cancelled) return
      if (data?.status === 'success') {
        setStats(data.response || {})
        setError('')
      } else {
        setError(data?.message || 'Failed to load dashboard stats.')
      }
      setLoading(false)
    })()
    return () => {
      cancelled = true
    }
  }, [])

  const cards = [
    { label: 'Total Members', value: stats?.total_members ?? '—' },
    { label: 'Donation Today', value: formatInr(stats?.donation_today) },
    { label: 'Donation Last Week', value: formatInr(stats?.donation_last_week) },
    { label: 'Donation Last Month', value: formatInr(stats?.donation_last_month) },
    { label: 'Total Outstanding', value: formatInr(stats?.total_outstanding) },
  ]

  return (
    <RequireModule moduleKey="dashboard">
      <PageHeader
        title="Dashboard"
        subtitle="Overview of members and donations."
      />
      {error ? <div className="manage-alert manage-alert-err">{error}</div> : null}
      {loading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-warning" role="status" />
        </div>
      ) : (
        <Row>
          {cards.map((card) => (
            <Col key={card.label} xs={12} sm={6} lg={4} className="mb-3">
              <div className="manage-stat">
                <div className="manage-stat-label">{card.label}</div>
                <div className="manage-stat-value">{card.value}</div>
              </div>
            </Col>
          ))}
        </Row>
      )}
    </RequireModule>
  )
}

export default DashboardPage
